import React, { useState } from "react";
import {
  Form,
  Button,
  Modal,
  Alert,
  Container,
  Row,
  Col,
  FloatingLabel,
} from "react-bootstrap";
import SignupModal from "./SignupModal";
import axios from "axios";
import { API_URL } from "../Config";
import { useNavigate } from "react-router-dom";

const LoginPage = ({ onLogin }) => {
  const [showSignup, setShowSignup] = useState(false);
  const handleCloseShowSignup = () => setShowSignup(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [validated, setValidated] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errors, setErrors] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validateForm = () => {
    const newErrors = {};
    const { email, password } = formData;

    if (!email) {
      newErrors.email = "Please enter email or mobile number";
    }

    if (!password) {
      newErrors.password = "Please enter your password";
    }

    // Check if identifier is a valid email or mobile number
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const mobilePattern = /^[0-9]{10}$/;

    if (!emailPattern.test(email) && !mobilePattern.test(email)) {
      newErrors.email = "Please enter a valid email or mobile number";
    }

    setErrorMessage(newErrors);

    return newErrors;
  };

  // Handle form submission
  const handleLogin = async (event) => {
    event.preventDefault();

    const validationError = validateForm();
    setErrors(validationError);
    setErrorMessage("");

    if (Object.keys(validationError).length === 0) {
      try {
        var url = API_URL + "auth/login";
        const response = await axios.post(url, formData);
        if (response.data.token.length !== 0) {
          onLogin();
          localStorage.setItem("accessToken", response.data.token);
          navigate("/dashboard");
        }
      } catch (error) {
        // Handle any errors
        if (error.response) {
          // The server responded with an error
          setErrors("Error response:" + error.response.data);
          setErrorMessage("Invalid login details.!");
        }
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  const handleForgotPassword = (event) => {
    event.preventDefault();
    setShowForgotPassword(false);
    setSuccessMessage("Password reset link sent to your email.");
  };

  return (
    <>
      <Container>
        <Row className="justify-content-center align-items-center">
          <Col md={8}>
            <div className="collaborate-section p-4 rounded bg-white">
              <Row>
                <Col md={6}>

                  <div className="my-6 flex items-center justify-center">
                    <span className="block h-px w-full bg-stroke dark:bg-dark-3"></span>
                    {/* <div className="block w-full min-w-fit bg-white px-3 text-center font-medium dark:bg-gray-dark">
                      sign in
                    </div> */}
                    <span className="block h-px w-full bg-stroke dark:bg-dark-3"></span>
                  </div>
                  <h3 className="text-center mb-4">Welcome Back</h3>
                  {successMessage && (
                    <Alert variant="success">{successMessage}</Alert>
                  )}
                  {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}

                  <Form noValidate validated={validated}>
                    <Form.Group controlId="formBasicEmail" className="mb-3">
                      <FloatingLabel
                        controlId="floatingInput"
                        label="Email / Mobile number"
                        className="mb-3"
                      >
                        <Form.Control
                          type="email"
                          placeholder="Enter email"
                          name="email"
                          required
                          value={formData.email}
                          onChange={handleChange}
                          isInvalid={!!errors.email}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.email}
                        </Form.Control.Feedback>
                      </FloatingLabel>
                    </Form.Group>

                    <Form.Group controlId="formBasicPassword" className="mb-3">
                      <FloatingLabel
                        controlId="floatingInput"
                        label="Password"
                        className="mb-3"
                      >
                        <Form.Control
                          type="password"
                          placeholder="Password"
                          name="password"
                          value={formData.password}
                          required
                          onChange={handleChange}
                          isInvalid={!!errors.password}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.password}
                        </Form.Control.Feedback>
                      </FloatingLabel>
                    </Form.Group>
                    <Button
                      className="w-100"
                      variant="primary"
                      type="submit"
                      onClick={handleLogin}
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "Logging you IN..." : "Login"}
                    </Button>

                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <Button
                        variant="link"
                        onClick={() => setShowForgotPassword(true)}
                        className="p-0"
                      >
                        Forgot Password?
                      </Button>
                    </div>

                  </Form>
                  {/* Forgot Password Modal */}
                  <Modal
                    show={showForgotPassword}
                    onHide={() => setShowForgotPassword(false)}
                    centered
                  >
                    <Modal.Header closeButton className="custom-modal-header">
                      <Modal.Title>Forgot Password</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <Form onSubmit={handleForgotPassword}>
                        <Form.Group
                          controlId="forgotPasswordEmail"
                          className="mb-3"
                        >
                          <Form.Label>Email</Form.Label>
                          <Form.Control
                            type="email"
                            placeholder="Enter your email"
                            required
                          />
                        </Form.Group>

                        <Button type="submit" className="w-100">
                          Reset Password
                        </Button>
                      </Form>
                    </Modal.Body>
                  </Modal>
                </Col>
                <Col md={6} className="justify-content-center align-items-center  text-center">
                  <Alert variant='info'>
                    <p><br /><br /><br /></p>
                    <p><h3>Hello, Friend !</h3> </p>
                    <p>Fill up personal information and start journey with us!<br /></p>
                    <p>
                      <Button
                        variant="primary"
                        onClick={() => setShowSignup(true)}
                        className="w-100"
                      >
                        Signup
                      </Button>
                    </p>
                    <p><br /><br /><br /></p>
                  </Alert>
                </Col>
              </Row>
            </div>

          </Col>
        </Row>
      </Container>
      <SignupModal show={showSignup} handleClose={handleCloseShowSignup} />
    </>
  );
};

export default LoginPage;
